module.exports = __webpack_public_path__ + "static/samantha-823e79d9354a82874b61ab32ed40eec5.jpg";